export default "/images/en.png?3a09fefe4a7f8ff4b6e3002e31912d9c";